import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from '../src/assets/i18n/en.json';
import translationFR from '../src/assets/i18n/fr.json';
// import HttpBackend from 'i18next-http-backend';

i18n
    // .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // backend: {
        //     loadPath: '/locales/{{lng}}/translation.json',
        // },
        resources: {
            en: {
                translations: translationEN
            },
            fr: {
                translations: translationFR
            },
        },
        lng: localStorage.getItem('i18nextLng') || 'en',
        fallbackLng: 'en',
        debug: false,
        ns: ['translations'],
        defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        // detection: {
        //     order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'], // Detection priority
        //     caches: ['localStorage', 'cookie'], // Cache the language in localStorage or cookies
        // },
    });

export default i18n;
